import React from 'react';
import TopLanding from '../../shared/components/TopLanding';

function NationalParks() {
    return (
        <div>
            <TopLanding />
        </div>
    )
}

export default NationalParks;